import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Col, Row } from 'react-grid-system'
import Flex from '../Flex/Flex'
import Avatar from '../Avatar/Avatar'
import Text from '../Text/Text'
import Store from '../Icons/Store'
import styles from './storeDescription.module.scss'

const StoreDescription = ({ store }) => {
  return (
    <Row className={styles.store} nogutter>
      <Col xl={1}>
        <Avatar
          image={store.logoImageUrl}
          size="medium"
          title={store.nameFantasy}
          radius={25}
        />
      </Col>

      <Col xl={7}>
        <Flex
          column
          justifyContent="space-around"
          height="100%"
          margin="0px 0px 0px 24px"
        >
          <Text size="lg" color="white">
            {store.nameFantasy}
          </Text>
          <Text color="gray" variation="light" font="custom" size="sm">
            {store.subsidiary} - {store.tabNumber}
          </Text>
          <Link to={`/extrato/loja/detalhe/${store.walletCode}`}>
            <Text size="xs" color="white">
              Ver dados
            </Text>
          </Link>
        </Flex>
      </Col>
      <div className={styles.storeImage}>
        <Store />
      </div>
    </Row>
  )
}

StoreDescription.propTypes = {
  store: PropTypes.shape({
    logoImageUrl: PropTypes.string,
    nameFantasy: PropTypes.string,
    subsidiary: PropTypes.string,
    tabNumber: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    walletCode: PropTypes.string
  }).isRequired
}

export default React.memo(StoreDescription)
